import { useState } from 'react';
import { ToggleTabs as Tabs, assets } from '@round/whitelabel-ui';
import TiktokCampaigns from '../../TiktokCampaigns/TiktokCampaigns';
import AggregatedPlatformStats from '../../PlatformHeadlineStats/PlatformHeadlineStats';
import styles from './TikTokTab.module.css';
import { Button } from '@round/whitelabel-ui';
import CreateTiktokCampaignModal from '../../TiktokCampaigns/CreateTiktokCampaignModal/CreateTiktokCampaignModal';
import { useProjectCampaigns } from '../../hooks/useProjectCampaigns';
import { PostUrlClipboardButton } from 'Modules/Plans/CopyToClipboard/PostUrlTable';
import TikTokPlatformPosts from './TikTokPlatformPosts';
import useCopyTiktokPostUrlsToClipboard from '../../hooks/copyToClipboard/useCopyTiktokPostUrlsToClipboard';

const { RowVertical: RowVerticalIcon, TiktokSolid: TikTokSolidIcon, Plus: PlusIcon } = assets;

const TikTokTab = () => {
    const [activeTab, setActiveTab] = useState<'campaigns' | 'posts'>('campaigns');
    const [isCreateCampaignModalOpen, setIsCreateCampaignModalOpen] = useState(false);
    const { data, isSuccess: areTikTokCampaignsInitialized } = useProjectCampaigns('tiktok');
    const tiktokCampaigns = data?.results;
    const copyPostUrlsToClipboard = useCopyTiktokPostUrlsToClipboard();

    return (
        <>
            <AggregatedPlatformStats platform="tiktok" />
            <Tabs activeTab={activeTab} onChange={setActiveTab}>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <Tabs.Menu>
                            <Tabs.Item name="campaigns" tooltip="View campaigns">
                                <RowVerticalIcon />
                            </Tabs.Item>
                            <Tabs.Item name="posts" tooltip="View posts" isDisabled={!areTikTokCampaignsInitialized}>
                                <TikTokSolidIcon />
                            </Tabs.Item>
                        </Tabs.Menu>

                        {activeTab === 'campaigns' && (
                            <div className={styles.actions}>
                                <PostUrlClipboardButton
                                    onClick={() => copyPostUrlsToClipboard(tiktokCampaigns ?? [])}
                                />

                                <Button
                                    appearance="primary"
                                    onClick={() => setIsCreateCampaignModalOpen(true)}
                                    iconLeft={<PlusIcon className={styles.plusIcon} />}
                                >
                                    Campaign
                                </Button>
                            </div>
                        )}
                    </div>

                    <Tabs.Panel name="campaigns">
                        <TiktokCampaigns onCreateCampaign={() => setIsCreateCampaignModalOpen(true)} />
                    </Tabs.Panel>

                    <Tabs.Panel name="posts" className={styles.postsTab}>
                        <TikTokPlatformPosts campaignIds={tiktokCampaigns?.map((c) => c.id) ?? []} />
                    </Tabs.Panel>
                </div>
            </Tabs>

            <CreateTiktokCampaignModal
                isOpen={isCreateCampaignModalOpen}
                closeModal={() => setIsCreateCampaignModalOpen(false)}
            />
        </>
    );
};

export default TikTokTab;
